/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import searchData from 'data';
import {
  TextField,
  Button,
  SnackbarNotification,
  LoadingBounce,
} from '@michelin/acid-components';
import {
  Grid,
  Typography,
  Link,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from '@material-ui/core';
import withTheme from '../../hocs/withTheme';
import { version } from '../../../package.json';

/*
If we need to parse query strings from URL, we need to go this route and look at this library
https://tylermcginnis.com/react-router-query-strings/

*/

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventNumber: '',
      vehicleId: '',
      eventDate: '',
      loading: false,
      valid: false,
      eventDateIsValid: true,
      noRecords: false,
      modalOpen: true,
    };
    this.handleSearchEventClick = this.handleSearchEventClick.bind(this);
    this.stateUpdater = this.stateUpdater.bind(this);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.handleClearFields = this.handleClearFields.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
  }

  componentWillMount() {
    // prettier-ignore
    if (this.props.match && this.props.match.params) {
      const urlParams = this.props.match.params;
      if (
        urlParams.caseId && urlParams.caseId !== '' &&
        urlParams.eventDate && urlParams.eventDate !== ''
      ) {
        this.setState({ eventNumber: urlParams.caseId, eventDate: urlParams.eventDate }, () => this.handleSearchEventClick());

      }
    }
  }

  validateDate = (date) => /^\d{2}(-|\/)\d{2}(-|\/)\d{4}$/.test(date); // this should probably change. allows for 01-01/2020, which isn't good

  stateUpdater(e) {
    this.setState({ noRecords: false }); // turn off no records on any change
    this.setState({ [e.target.name]: e.target.value }, this.checkState);
    if (e.target.name === 'eventDate') {
      // check data is valid
      if (!this.validateDate(e.target.value) && e.target.value !== '') {
        this.setState({ eventDateIsValid: false });
      } else {
        this.setState({ eventDateIsValid: true });
      }
    }
  }

  handleCloseModal() {
    window.location.href =
      'https://live-track.oncall.misp-solutions.com/?redirect=true';
    // this.setState({ modalOpen: false });
  }

  handleOpenModal() {
    this.setState({ modalOpen: true });
  }

  handleSearchEventClick() {
    this.setState({ loading: true });
    // TODO: get data from API and pass it to the event viewer page
    const args = {};
    if (this.state.vehicleId !== '') {
      args.unit = this.state.vehicleId;
    }

    if (this.state.eventNumber !== '') {
      args.eventNumber = String(this.state.eventNumber).toUpperCase();
    }

    if (this.state.eventDate !== '') {
      args.eventDate = String(this.state.eventDate).replace(/-/g, '/');
    }

    searchData(args).then((data) => {
      if (data.eventId !== '') {
        this.setState({ loading: false });
        let newPath = '/events';
        // prettier-ignore
        if (
          this.props.match.params.caseId &&
          this.props.match.params.caseId !==
          '') {
          newPath += `/?caseID=${this.props.match.params.caseId}`;
        }
        this.props.history.push(newPath, {
          event: data,
        });
      } else {
        // raise error
        this.setState({ noRecords: true });
        this.setState({ loading: false });
        this.setState({ valid: false });
      }
    });
    /*
    getEvent(this.state).then(data => {
      this.props.history.push('/events', {
        event: data,
      });
    });
    */
  }

  handleHelpClick(e) {
    this.props.history.push('/help');
  }

  checkState() {
    let valid =
      !!this.state.eventNumber +
        !!this.state.vehicleId +
        !!this.state.eventDate >=
      2;
    valid = valid && !!this.state.eventDateIsValid;
    this.setState({ valid });
  }

  handleClearFields() {
    this.setState({ eventNumber: '' });
    this.setState({ vehicleId: '' });
    this.setState({ eventDate: '' });
    this.setState({ valid: false });
  }

  renderWarningMessage = (message, type) => (
    <SnackbarNotification type={type} title={type} message={message} />
  );

  render() {
    const termsVisible = true;
    const helpVisible = true;
    const { theme } = this.props;

    const styles = {
      pageBackground: {
        height: '100vh',
        paddingTop: '2rem',
        backgroundColor: theme.palette.primary.main,
      },
      cardDiv: {
        background: theme.palette.common.white,
        borderRadius: '2px',
        margin: '5px 5px 10px',
        padding: '5px',
        position: 'relative',
        boxShadow: `2px 2px 4px 0px ${theme.palette.grey[300]}`,
      },
      cardBody: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
      },
      textField: {
        paddingTop: '.25rem',
      },
    };

    const bgColor = theme.palette.primary.main;
    const fgColor = theme.palette.getContrastText(theme.palette.primary.main);

    return (
      <div className="container-fluid" style={styles.pageBackground}>
        <div className="row" style={{ backgroundColor: bgColor }}>
          <div className="col-sm-12 col-md-12">
            <Dialog
              fullScreen={false}
              key="decommDialog"
              open={this.state.modalOpen}
            >
              <DialogTitle>PO/Event Viewer Decommissioning</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Event Viewer has been shut down as of January 15, 2024. Users
                  will need a B2B or MyPortal account to make use of Live Track
                  to track event data going forward. Clicking the "OK" button
                  will take you to Live Track. If you have the PO Event Viewer
                  bookmarked, please remove the bookmark or replace it with one
                  to Live Track.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleCloseModal} variant="contained">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </div>
          <div></div>
        </div>
        <div className="row" style={{ backgroundColor: bgColor }}>
          <div className="col-sm-12 col-md-4 text-center text-md-left">
            <Typography
              variant="subtitle2"
              style={{ color: fgColor, marginBottom: '4px' }}
            >
              Michelin Americas Truck Tires
            </Typography>
            <Typography
              variant="caption"
              style={{ color: fgColor, marginBottom: '8px' }}
            >
              Emergency Road Service
            </Typography>
            <Typography
              style={{
                color: fgColor,
                fontSize: '26px',
              }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="tel:18008473911"
                style={{
                  color: fgColor,
                  fontSize: '26px',
                }}
                id="phoneNumberLetters"
              >
                1-800 TIRE 911
              </a>
            </Typography>
            <Typography
              variant="caption"
              style={{ color: fgColor, marginBottom: theme.spacing(1) }}
            >
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="tel:18008473911"
                style={{ color: fgColor, marginBottom: theme.spacing(1) }}
                id="phoneNumberNormal"
              >
                1-800-847-3911
              </a>
            </Typography>
          </div>
          <div className="col-md-12 col-lg-4">
            <div style={styles.cardDiv}>
              <div style={{ textAlign: 'center' }}>
                <img
                  src="/img/ONCALL_EVENT_VIEWER_v1a.jpg"
                  alt="header"
                  style={{ height: 'auto', maxWidth: '99%' }}
                />
              </div>
              <div style={styles.cardBody}>
                <Grid container direction="column" sp>
                  <Grid item>
                    <Typography variant="caption">Welcome to</Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="subtitle2"
                      style={{ fontSize: '18px' }}
                    >
                      Michelin&reg; ONCall&trade; Event Viewer
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">
                      Complete 2 of the 3 fields below to search
                    </Typography>
                  </Grid>
                  <Grid item style={styles.textField}>
                    <TextField
                      id="eventNumberField"
                      name="eventNumber"
                      label="Event Number"
                      onChange={this.stateUpdater}
                      placeholder="D000001"
                      value={this.state.eventNumber}
                    />
                  </Grid>
                  <Grid item style={styles.textField}>
                    <TextField
                      id="vehicleIDField"
                      name="vehicleId"
                      label="Vehicle ID"
                      onChange={this.stateUpdater}
                      placeholder="123456"
                      value={this.state.vehicleId}
                    />
                  </Grid>
                  <Grid item style={styles.textField}>
                    <TextField
                      id="eventDateField"
                      name="eventDate"
                      label="Event Date"
                      onChange={this.stateUpdater}
                      placeholder="MM-DD-YYYY"
                      value={this.state.eventDate}
                    />
                    {!this.state.eventDateIsValid &&
                      this.renderWarningMessage(
                        'Invalid Date Format',
                        'warning',
                      )}
                  </Grid>
                  <Grid item>
                    <Typography>&nbsp;</Typography>
                  </Grid>
                  {helpVisible}
                </Grid>
                {this.state.noRecords && (
                  <Grid item>
                    {this.renderWarningMessage('No Records Found', 'error')}
                  </Grid>
                )}
                <Grid
                  container
                  direction="row-reverse"
                  justifyContent="space-between"
                >
                  <Grid item>
                    <Button
                      disabled={this.state.loading || !this.state.valid}
                      onClick={this.handleSearchEventClick}
                      variant="contained"
                      id="searchButton"
                    >
                      SEARCH EVENT
                      {this.state.loading ? (
                        <div style={{ position: 'fixed' }}>
                          <LoadingBounce />
                        </div>
                      ) : (
                        ''
                      )}
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ backgroundColor: bgColor }}>
          <div className="col-12 text-center">
            {termsVisible && (
              <div style={{ color: fgColor }}>
                By using this website you agree to the &nbsp;
                <Link href="/terms/">
                  <Typography
                    variant="caption"
                    style={{ color: fgColor, display: 'inline-block' }}
                    id="termsPageLink"
                  >
                    <u>Terms and Conditions</u>
                  </Typography>
                </Link>
                <br />
                <Link href="/privacy">
                  <Typography
                    variant="caption"
                    style={{ color: fgColor }}
                    id="privacyPolicyLink"
                  >
                    <u>Privacy Policy</u>
                  </Typography>
                </Link>
              </div>
            )}
            <Typography>&nbsp;</Typography>
            <Link href="/help/">
              <Typography
                variant="caption"
                style={{
                  fontSize: '17.5px',
                  color: fgColor,
                  display: 'block',
                }}
                id="helpPageLink"
              >
                <u>Need Help?</u>
              </Typography>
            </Link>
            <Typography variant="caption" style={{ color: fgColor }}>
              Version: {version}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

Home.defaultProps = {
  match: {
    caseId: '',
    eventDate: '',
  },
};

export default withTheme()(Home);
